<template>
  <div>
    <a
       class="regular-line-button-blue70"
       @click="handleClick"
    >
      <span>
        {{ $t('menu.contact_us')}}
      </span>
    </a>
    <MailModal/>
    <ContactModal/>
  </div>
</template>
<script>
import {
  _SERVICE_MAIL,
} from "@/static";
import MailModal from '@/components/modal/mailModal'
import ContactModal from '@/components/modal/contactModal'

export default {
  name: 'Contact',
  components: {
    MailModal,
    ContactModal,
  },
  props: {
    visibilityProps: Boolean,
  },
  data() {
    return {
      mail: _SERVICE_MAIL,
    }
  },
  methods: {
    handleClick() {
      if (process.env.VUE_APP_API_DOMAIN === 'https://test.api.rebless.pro')
        this.$modal.show('contact-modal')
      else
        this.$modal.show('mail-modal')
    }
  }
}
</script>
<style lang="scss" scoped>
</style>